import React from 'react';

import { Button } from '@mui/material';
import CopyBtn from '../../CopyBtn';
import EditIcon from '@mui/icons-material/Edit';
import FieldErrorIcon from '@mui/icons-material/ErrorOutline';

import Trpl from '../../Trpl';
import Node from '../../Node';
import AnimatedButton from '../../AnimatedSavingBtn';

import ArrowTooltipCss from '../../ArrowTooltipCss';

import { isObjectPredicate, isJsonObject, onlyUnique } from '../../../utils';

export default ({
  rst,
  node,
  mode,
  nodeId,
  classes,
  collectedTrpls,
  openTrplFormFull,
  individualsNodes,
  onRstTypeBtnClick,
  trplSaveDataImport,
  openTrplFormWithRst,
  onNodeRemoveBtnClick,
  isRestrictionOverrided,
}) => {

  const isRstBtn = rst.type === 'BUTTON';
  const isMandatoryField = collectedTrpls.length < rst.subjectMinBound;
  const isConstant = rst && rst.isConstant;

  return (
    <div
      style={{
        paddingLeft: '1px',
        display: `${!isRstBtn ? '' : 'flex'}`,
      }}
    >
      {isRstBtn ? (
        <div
          style={{
            width: '100%',
            padding: '1px',
            overflow: 'hidden',
          }}
        >
          <AnimatedButton
            height={'19px !important'}
            minWidth={'fit-content !important'}
            onClick={() => onRstTypeBtnClick(rst.id, nodeId)}
          >
            <span id={rst.id}>{rst.btn_title || 'Do action'}</span>
          </AnimatedButton>
        </div>
      ) : (
        collectedTrpls.map((trpl, trplIndex) => {
          const isUrl = trpl.type === 'URL';
          const trplsErrors = trpl && trpl.warnings && trpl.warnings
            .filter(warnings => warnings && warnings.length)
            .flat()
            .filter(onlyUnique)
            .join('\n')

          if (isObjectPredicate(trpl) || (rst && rst.obj_editable_frm)) {
            const isNodeEditable = rst && rst.obj_editable_frm;

            return (
              <div
                style={{
                  height: '21px',
                  cursor: isNodeEditable ? 'pointer' : '',
                }}
                className={classes.trplTableNodes}
                key={trplIndex}
              >
                <Node
                  isLink
                  size="xs"
                  nodeId={trpl.oid}
                  formEdit={isNodeEditable}
                  nodes={individualsNodes}
                  node={individualsNodes && individualsNodes[trpl.oid]}
                  onClick={() => {
                    if (isNodeEditable) {
                      openTrplFormFull({
                        node: individualsNodes[trpl.oid],
                        mode: 'edit',
                        initialNodeId: nodeId,
                        obj_editable_frm: rst.obj_editable_frm,
                      });
                    }
                  }}
                  onRemoveClick={() => {
                    onNodeRemoveBtnClick(nodeId, rst.id, trpl.tid);
                  }}
                />
              </div>
            );
          } else {
            return (
              <div key={trplIndex} className={classes.alignCenter}>
                <Trpl
                  rst={rst}
                  trpl={trpl}
                  nodeId={nodeId}
                  key={trplIndex}
                  classes={classes}
                  trplSaveDataImport={trplSaveDataImport}
                />
                {trpl.warnings && trplsErrors ? (
                  <div>
                    <ArrowTooltipCss text={trplsErrors}
                      style={{
                        bottom: '1px',
                        position: 'absolute',
                        display: 'contents',
                      }}
                    >
                      <FieldErrorIcon className={`trpl-add-icon ${classes.mandatoryCellIcon}`} />
                    </ArrowTooltipCss>
                  </div>
                ) : null}

                {isUrl ? (
                  <div>
                    <ArrowTooltipCss text="Copy to clipboard"
                      style={{
                        bottom: '1px',
                        position: 'absolute',
                        display: 'contents',
                      }}
                    >
                      <CopyBtn
                        text={trpl.val}
                        copyIconStyles={{
                          fontSize: '16px',
                          marginLeft: '7px',
                        }}
                      />
                    </ArrowTooltipCss>
                  </div>
                ) : null}
              </div>
            );
          }
        })
      )}

      {isMandatoryField ? (
        <ArrowTooltipCss
          placement='right'
          text={`Mandatory field\n`}
          style={{
            left: '1px',
            top: '1px',
            position: 'absolute',
            display: 'contents',
          }}
        >
          <FieldErrorIcon className={`trpl-add-icon ${classes.mandatoryCellIcon}`} />
        </ArrowTooltipCss>
      ) : null}

      {isRestrictionOverrided || mode !== 'WRITE' || (rst && !rst.editable)
        || isRstBtn || isConstant || Array.isArray(rst) || Array.isArray(rst.id)
        || (rst.renderer && rst.renderer.editable_checkbox && rst.type === 'BOOLEAN')
          || ((isJsonObject(rst) && rst.hasOwnProperty('pids') && Array.isArray(rst.id))
          || (isJsonObject(rst) && rst.hasOwnProperty('custom_component'))) ? null :
        <div
          className={`trpl-icon ${classes.trplFormIcon}`}
          onClick={() => openTrplFormWithRst(node, rst)}
        >
          <ArrowTooltipCss
            placement='right'
            text={'Edit'}
            style={{
              right: '1px',
              top: '1px',
              position: 'absolute',
            }}
          >
            <EditIcon className={`trpl-add-icon ${classes.addTrplIcon}`}/>
          </ArrowTooltipCss>
        </div>}
    </div>
  )
};
